var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('budgets-list',{attrs:{"budgets":_vm.budgets,"mentor":false,"showOverlay":_vm.showOverlay},on:{"add":_vm.add,"save":_vm.save,"cancel":_vm.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }